import { observer } from 'mobx-react';
import React from 'react';

@observer
class ActionBar extends React.Component {
  render() {
    return (
      <div className="nowrap flex-row">
        <div className="flex-both">Status</div>
        <div className="flex-none">action</div>
      </div>
    );
  }
}

export default ActionBar;
